/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {error} from '@ion/core/src/logger/logger';

export interface useLoadFiltersType {
  type: string;
  accountId: number | number[];
  getFilterOptions?: (accountId) => Promise<{ result: any; filterResult: any;}>;
  hasErrors?: boolean;
  isLoading?: boolean;
}

export const useLoadFilters = ({
  accountId,
  getFilterOptions,
  hasErrors = false,
  isLoading = false,
  type = ''
}: useLoadFiltersType): {
    fetchData: () => Promise<void>;
    options: any [],
    filterOptions: any[],
    errors: any,
    loading: boolean
  } => {
  const [loading, setLoading]                 = useState(isLoading);
  const [options, setOptions]                 = useState([]);
  const [filterOptions, setFilterOptions]     = useState([]);
  const [errors, setErrors]                   = useState(hasErrors);
  const fetchData = async() => {
    setLoading(true);
    setErrors(false);
    try {
      const {result, filterResult} =  await getFilterOptions(accountId);

      const isValid = type === translate('common:filters.assets') ? result?.length : result?.length;
      if (isValid) {
        setOptions(result);
        setFilterOptions(filterResult);
      } else {
        setErrors(true);
      }
    } catch (err) {
      error(`Failed to load ${type}. Error: ${err.message}`);
      setErrors(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setErrors(false);
  }, [accountId]);
  return {fetchData, options, filterOptions, errors, loading};
};
